var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"logo",attrs:{"aria-label":_vm.$config.WEBSITE_NAME,"to":_vm.localePath({ name: 'index' })},domProps:{"innerHTML":_vm._s(require(`@/assets/images/logo.svg?include`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }